import React, { useEffect, useReducer } from "react";
import { Autocomplete, Button, Menu, Tooltip } from "../../index";
import { filtersReducer } from "../reducer";
import { OPERATORS_TO_TEXT, isMultipleOperator, isValueSelected, } from "../utils";
import styles from "./filtersForm.module.scss";
import ValueField from "./ValueField";
const FiltersForm = ({ initialFilterData, filterOptions, onSave, onClose, isFilterActive, groupFiltersBy, }) => {
    var _a, _b;
    const [filter, filterDispatch] = useReducer((filtersReducer), initialFilterData);
    const initialFilterName = (_a = initialFilterData === null || initialFilterData === void 0 ? void 0 : initialFilterData.name) !== null && _a !== void 0 ? _a : null;
    const hasNoInitialValues = (initialFilterData === null || initialFilterData === void 0 ? void 0 : initialFilterData.values.length) === 0;
    useEffect(() => {
        var _a, _b;
        if (initialFilterName !== null &&
            hasNoInitialValues &&
            !filterOptions[initialFilterName].isLoading) {
            (_b = (_a = filterOptions[initialFilterName]).onFilterSelect) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }, [filterOptions, initialFilterName, hasNoInitialValues]);
    const handleFilterTypeChange = (filterName) => {
        var _a, _b;
        if (filterName) {
            (_b = (_a = filterOptions[filterName]).onFilterSelect) === null || _b === void 0 ? void 0 : _b.call(_a);
            filterDispatch({
                type: "SELECT_FILTER",
                payload: {
                    name: filterName,
                    operation: filterOptions[filterName].operations[0],
                    values: [],
                },
            });
        }
        else {
            filterDispatch({ type: "RESET_FILTER" });
        }
    };
    const handleOperationChange = (operator) => {
        if (!filter)
            return;
        filterDispatch({
            type: "UPDATE_OPERATOR",
            payload: operator,
        });
        if (operator && !isMultipleOperator(operator) && filter.values.length > 1) {
            filterDispatch({
                type: "UPDATE_VALUE",
                payload: [filter.values[0]],
            });
        }
    };
    const handleValueChange = (value) => {
        if (!filter)
            return;
        filterDispatch({
            type: "UPDATE_VALUE",
            payload: value,
        });
    };
    return (React.createElement("div", { className: styles.form },
        React.createElement("div", { className: styles.filter },
            React.createElement("div", { className: styles["field-label"] }, "Filter by"),
            React.createElement(Autocomplete, { id: "filter-type-autocomplete", value: (_b = filter === null || filter === void 0 ? void 0 : filter.name) !== null && _b !== void 0 ? _b : null, disabled: initialFilterData !== null, filterSelectedOptions: true, options: Object.values(filterOptions)
                    .filter((filter) => filter.isOptionHidden !== true)
                    .map((filter) => filter.name), getOptionLabel: (filterName) => filterOptions[filterName].label, getOptionDisabled: (filterName) => isFilterActive(filterName) ||
                    filterOptions[filterName].isOptionDisabled === true, onChange: (_event, value) => handleFilterTypeChange(value), groupBy: groupFiltersBy, renderGroup: (params) => (React.createElement("li", { key: params.key, className: styles["filter-group"] },
                    React.createElement(Menu.GroupTitle, null, params.group),
                    React.createElement("ul", { className: styles["filter-group-list"] }, params.children))), renderOption: (props, filterName) => {
                    const isDisabled = filterOptions[filterName].isOptionDisabled === true;
                    let disabledReason = isDisabled
                        ? filterOptions[filterName].disabledReason
                        : undefined;
                    if (isFilterActive(filterName)) {
                        disabledReason = "Filter already exists";
                    }
                    if (disabledReason) {
                        return (React.createElement(Tooltip, { key: filterName, title: disabledReason },
                            React.createElement("div", { className: styles["disabled-option"] },
                                React.createElement("li", { ...props },
                                    React.createElement("span", null, filterOptions[filterName].label)))));
                    }
                    else {
                        return React.createElement("li", { ...props }, filterOptions[filterName].label);
                    }
                } })),
        React.createElement("div", { className: styles.operator },
            React.createElement("div", { className: styles["field-label"] }, "Operator"),
            React.createElement(Autocomplete, { id: "operator-autocomplete", value: filter ? filter.operation : null, getOptionLabel: (option) => (option ? OPERATORS_TO_TEXT[option] : ""), disabled: !filter, filterSelectedOptions: true, options: filter ? filterOptions[filter.name].operations : [], onChange: (_event, value) => handleOperationChange(value) })),
        filter && filter.operation && (React.createElement(ValueField, { filter: filter, filterOption: filterOptions[filter.name], onChange: handleValueChange })),
        React.createElement("div", { className: styles.actions },
            React.createElement(Button, { id: "cancel", color: "secondary", onClick: onClose, size: "small" }, "Cancel"),
            React.createElement(Button, { id: "save", color: "primary", disabled: !filter || !filter.operation || !isValueSelected(filter.values), size: "small", onClick: () => {
                    if (filter && filter.operation !== null) {
                        onSave(filter.name, {
                            operation: filter.operation,
                            values: filter.values,
                        });
                    }
                    onClose();
                } }, "Save"))));
};
export default FiltersForm;
//# sourceMappingURL=FiltersForm.js.map